import { lang } from 'utils/lang'
import zhLocale from '@/lang/zh'
import enLocale from '@/lang/en'

const locale = lang === 'zh' ? zhLocale : enLocale

export const setTitle = {
  created() {
    const name = this.$route.name
    document.title = locale[name].pageTitle
  }
}



// WEBPACK FOOTER //
// ./src/components/mixin/title.js